import React from 'react';
import '../../../styles/style.css';

const LocationDetails = ({ details }) => {

  if (!details || details.length === 0) {
    return null;
  }

  // Сортировка массива по полю sort_order
  const sortedDetails = details.sort((a, b) => a.sort_order - b.sort_order);

  return (
    <div className="locationAdditionalDesc flex-column">
      <div className="locationAdditionalDescStick"></div>
      
      
      {sortedDetails.map((detail, index) => {
        // Обработка описания: разбивка по \n или \\n
        const descriptionLines = detail.description
          ? detail.description.split(/\r?\n|\\n/).filter(line => line.trim() !== '')
          : [];

        return (
        <div key={index} className="workingHours">
          <b>{detail.title}</b>:
          
          {descriptionLines.length > 0 ? (
            <>
              {/* Проверяем, начинался ли текст с \n или \\n */}
              {(/^\\?n/.test(detail.description.trimStart()) || detail.description.startsWith('\n')) ? (
                // Если ДА — начинаем с новой строки (и все абзацы как блоки)
                <>
                  {descriptionLines.map((line, i) => (
                    <p key={i}>
                      {line.trim()}
                    </p>
                  ))}
                </>
              ) : (
                // Если НЕТ — первый абзац в строке с заголовком
                <>
                  {' '}
                  {descriptionLines[0].trim()}
                  {/* Остальные — с новой строки и отступом */}
                  {descriptionLines.slice(1).map((line, i) => (
                    <p key={i}>
                      {line.trim()}
                    </p>
                  ))}
                </>
              )}
            </>
          ) : (
            <span> Нет данных</span>
          )}
        </div>
      );

        // return (
        //   <div key={index} className="workingHours">
        //     <b>{detail.title}</b>:
        //       {descriptionLines.map((line, i) => (
        //         <p key={i}>{line.trim()}</p>
        //       ))}
        //   </div>
        // );
      })}
    </div>
  );
};

export default LocationDetails;